import { PATHNAMES } from 'constants/constants';
import type { PatentDraftMode } from 'features/PatentDrafting/types/patentDraft';
import { draftNavigationPaths } from 'features/PatentDrafting/types/patentDraft';
import { ResourceType } from 'gen/api';

export const getResourcePath = (
  resourceType: ResourceType,
  resourceId: string,
  draftingMode?: PatentDraftMode,
): string | null => {
  switch (resourceType) {
    case ResourceType.FTO:
      return `${PATHNAMES.ftoSearch}?id=${resourceId}`;
    case ResourceType.INVENTION_DISCLOSURE:
      return `${PATHNAMES.inventionDisclosure}/${resourceId}`;
    case ResourceType.INFRINGEMENT_DETECTION:
      return `${PATHNAMES.infringementDetectionSearch}?id=${resourceId}`;
    case ResourceType.AI_SEARCH:
      return `${PATHNAMES.aiSearch}/${resourceId}`;
    case ResourceType.PATENT_DRAFT:
      return draftingMode
        ? `${draftNavigationPaths[draftingMode]}/${resourceId}`
        : `${PATHNAMES.patentDrafting}/${resourceId}`;
    case ResourceType.OFFICE_ACTION_2:
      return `${PATHNAMES.officeActionsV2Hub}/${resourceId}`;
    case ResourceType.LITIGATION_ASSISTANT:
      return `${PATHNAMES.litigationAssistant}/${resourceId}`;
    case ResourceType.PUBLICATION_TRACKER_TOPIC:
      return `${PATHNAMES.anticipation}/${resourceId}`;
    case ResourceType.GENERAL_ASSISTANT:
      return `${PATHNAMES.generalAssistant}/${resourceId}`;
    case ResourceType.INVENTION_ASSISTANT:
      return `${PATHNAMES.inventionAssistant}/${resourceId}`;
    default:
      return null;
  }
};
